import { path, pathOr } from 'ramda';
import {
  SET_IS_RENDERED,
  SET_IS_LOADING,
  SET_USE_DEBUG_MODE,
  SET_LOCAL_GAME_LAUNCH_MODE,
  SET_IS_THEME_APPLIED,
  LOCALIZATION_INITIALIZED,
} from '../../../constants/initialization';

export const initialState = {
  isLoading: false,
  isRendered: false,
  useDebug: false,
  useLocalGameLaunchMode: false,
  isThemeApplied: false,
  isLocalizationInitialized: false,
};

// prettier-ignore
const initialization = (state = initialState, { type, payload }) => { //NOSONAR
  switch (type) {
    case SET_IS_LOADING:
      return { ...state, isLoading: payload };

    case SET_IS_RENDERED:
      return { ...state, isRendered: payload };

    case SET_USE_DEBUG_MODE:
      return { ...state, useDebug: payload };

    case SET_LOCAL_GAME_LAUNCH_MODE:
      return { ...state, useLocalGameLaunchMode: payload };

    case SET_IS_THEME_APPLIED:
      return { ...state, isThemeApplied: payload };

    case LOCALIZATION_INITIALIZED:
      return { ...state, isLocalizationInitialized: payload };

    default:
      return state;
  }
};

export default initialization;

/**
 * SELECTORS
 */

export const isRenderedSelector = (state) =>
  pathOr(
    initialState.isRendered,
    ['app', 'initialization', 'isRendered'],
    state
  );

export const isLoadingSelector = (state) =>
  pathOr(initialState.isLoading, ['app', 'initialization', 'isLoading'], state);

export const isDebugModeSelector = (state) =>
  path(['app', 'initialization', 'useDebug'], state);

export const isLocalGameLaunchMode = (state) =>
  path(['app', 'initialization', 'useLocalGameLaunchMode'], state);

export const isThemeAppliedSelector = (state) =>
  path(['app', 'initialization', 'isThemeApplied'], state);

export const isLocalizationInitializedSelector = (state) =>
  path(['app', 'initialization', 'isLocalizationInitialized'], state);
